import { useEffect, useRef, useState, type FC } from "react";
import { motion } from "framer-motion";

import Header from "../common/Header";
import Footer from "../common/Footer";
import { Image } from "../common/ui/Image";

interface Props {
  className?: string;
  children: React.ReactNode;
  sideBanner: {
    title: string;
    imageUrl: string;
    points: string[];
  };
}

const LoginLayout: FC<Props> = ({ children, className, sideBanner }) => {
  const { title, imageUrl, points } = sideBanner;
  const mainContainerRef = useRef<HTMLDivElement>(null);
  const [marginWidth, setMarginWidth] = useState(0);

  useEffect(() => {
    const calculateMarginWidth = () => {
      if (mainContainerRef.current) {
        const containerWidth = mainContainerRef.current.offsetWidth;
        const windowWidth = window.innerWidth;
        const calculatedMarginWidth = (windowWidth - containerWidth) / 2;
        setMarginWidth(calculatedMarginWidth);
      }
    };

    calculateMarginWidth();
    window.addEventListener("resize", calculateMarginWidth);

    return () => {
      window.removeEventListener("resize", calculateMarginWidth);
    };
  }, []);
  // console.log({ marginWidth });

  return (
    <>
      <Header />
      <div className={` w-full md:h-[calc(100vh-48px-33px)] flex ${className ?? ""}`}>
        <div style={{ width: `${marginWidth}px` }} className="h-full bg-brand-light "></div>
        <div ref={mainContainerRef} className="flex flex-col w-full max-w-mainContainer h-full">
          <motion.main className="flex flex-col md:flex-row h-full w-full">
            <motion.div
              className=" w-full bg-brand-light h-full py-11 px-5 xl:px-0 md:flex items-center flex-col"
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h1 className="leading-1.5 font-black text-base md:text-32 text-text-label w-full pt-5 md:pt-0">{title}</h1>
              {points.length > 0 && (
                <div className="flex md:pt-6 py-4 md:pb-16 px-2 md:px-4 w-full ">
                  <ul className="w-1/2 pr-4">
                    {points.slice(0, Math.ceil(points.length / 2)).map((point, i) => (
                      <li key={i} className="mb-2 list-disc text-text-label">
                        <span className="text-10 md:text-base font-normal !leading-normal">{point}</span>
                      </li>
                    ))}
                  </ul>
                  <ul className="w-1/2 md:pl-4">
                    {points.slice(Math.ceil(points.length / 2)).map((point, i) => (
                      <li key={i} className="mb-2 list-disc text-text-label">
                        <span className="text-10 md:text-base font-normal !leading-normal">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <Image src={imageUrl} alt="bg-image" />
            </motion.div>
            {children}
          </motion.main>
        </div>
        <div style={{ width: `${marginWidth}px` }} className=" bg-white h-full"></div>
      </div>
      <Footer />
    </>
  );
};

export default LoginLayout;
